<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step0.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.step0.title') }}</h1>
        <p class="project-description">{{ Translator('soprasolar.project.step0.description') }}</p>
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="formType" class="std-form">
          <div class="form-group">
            <div :class="['radio-tile', 'radio-tile--terrace']">
              <input type="radio" name="type" v-model="form.type" required value="terrace" id="type-terrace">
              <label for="type-terrace" class="radio-container">
                <p class="radio-label">{{ Translator('soprasolar.project.step0.form.type.terrace') }}</p>
                <div class="radio-media">
                  <img src="/assets/soprasolar/images/project/type-terrace.jpg" :alt="Translator('soprasolar.project.step0.form.type.terrace')">
                </div>
              </label>
            </div>
            <div :class="['radio-tile', 'radio-tile--shade']">
              <input type="radio" name="type" v-model="form.type" required value="shade" id="type-shade">
              <label for="type-shade" class="radio-container">
                <p class="radio-label">{{ Translator('soprasolar.project.step0.form.type.shade') }}</p>
                <div class="radio-media">
                  <img src="/assets/soprasolar/images/project/type-shade.jpg" :alt="Translator('soprasolar.project.step0.form.type.shade')">
                </div>
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="formType" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
  .project-wrapper {
    @include vertical-spacing-inner-top;
  }
  .radio-tile {
    & + .radio-tile {
      margin-top: rem(20);
    }
    input {
      @include hideAccess;
      &:checked {
        & + .radio-container .radio-label::after {
          background-color: $color-second;
        }
      }
      &:focus {
        & + .radio-container {
          border-color: rgba($color-second, .5);
          box-shadow: 0 0 0 rem(3) rgba($color-second, .5);
        }
      }
    }
    .radio-container {
      cursor: pointer;
      display: block;
      padding: rem(20);
      border-radius: rem(16);
      border: rem(1) solid $grey-light;
      transition: border-color $transition-out-hover;
      &:hover, &:focus {
        border-color: $color-second;
        transition: border-color $transition-in-hover;
      }
    }
    .radio-label {
      position: relative;
      padding-bottom: rem(15);
      padding-left: rem(40);
      font-weight: bold;
      &::after,
      &::before {
        content: '';
        display: block;
        border-radius: 100%;
        border: rem(1) solid $color-second;
        width: rem(18);
        height: rem(18);
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .radio-media {
      position: relative;
      overflow: hidden;
      padding-top: 36%;
      img {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-project/services/AppControl';

export default {
  name: 'step-0',
  components: {},
  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {}
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas && this.datas.step0) this.form = this.datas.step0;
  },

  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        if(this.datas && this.datas.step0 && this.form.type !== this.datas.step0.type) {
          AppControlService.delete('step2');
          AppControlService.delete('step3');
          AppControlService.delete('step4');
          AppControlService.delete('step5');
        }
        AppControlService.update('step0', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onNext() {
      AppControlService.goToNextStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step0) this.form = this.datas.step0;
    }
  }
};
</script>